<template>
  <div class="pc-skeleton-sign-in__card pc-sign-in__card-sign-in container">
    <div class="pc-skeleton-sign-in__card-logo">
      <AnimatedPlaceholder class="pc-skeleton-password-request__title" width="250px" height="45px" />
      <AnimatedPlaceholder width="150px" height="45px" />
      
    </div>
    <div class="pc-skeleton-sign-in__card-inputs">
      <AnimatedPlaceholder class="pc-skeleton-sign-in__card-inputs-first" width="100%" height="45px" />
      <AnimatedPlaceholder width="100%" height="45px" />
    </div>
    <div class="pc-skeleton-sign-in__card-button">
      <AnimatedPlaceholder class="pc-skeleton-password-request__button" width="100%" height="45px" border-radius="50px" />
      <AnimatedPlaceholder width="100%" height="45px" border-radius="50px" />
     
    </div>
    <div class="pc-skeleton-sign-in__card-info"><AnimatedPlaceholder width="200px" height="12px"  />
    </div>
      <div class="pc-skeleton-sign-in__card-info-second">
      <AnimatedPlaceholder width="80px" height="12px"   border-radius="0"/>
      <AnimatedPlaceholder width="100px" height="12px"  border-radius="0"/>
    </div>
    
  </div>
</template>

<script >
import AnimatedPlaceholder from '../../../global/animators/AnimatedPlaceholder';

export default {
    components: {
      AnimatedPlaceholder
    }
}

</script>

<style  >



</style>